<template>
  <div v-cloak id="sale-product">
    <div class="vx-row mb-4 flex px-4 justify-between gap-4">
      <div class="flex gap-4">
        <vs-button
          @click="assignProduct()"
          class="bg_l_green"
          v-has-permission="permission64"
        >
          <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("AssignProductToContract") }}
        </vs-button>
        <vs-button
          @click="downloadFile()"
          class="bg_m_blue"
          v-has-permission="permission65"
        >
          <feather-icon icon="FileIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("DownloadContractProducts") }}
        </vs-button>
      </div>
      <div class="flex gap-4 flex-grow">
        <div
          class="flex"
          v-has-permission="'AssignCumulativeBaseSalePriceItemWithExcelFile'"
        >
          <label class="custom-file-upload">
            <input
              type="file"
              id="file"
              ref="baseSalePriceFile"
              v-on:change="handleFileUploadBaseSalePrice()"
            />
            <feather-icon
              icon="PaperclipIcon"
              svgClasses="h-4 w-4"
              class="ico"
            />
            {{ $t("UploadBaseSalePrice") }}
            <span v-if="baseSalePriceUploadedFileName" class="file-name">{{
              baseSalePriceUploadedFileName
            }}</span>
          </label>
          <vs-button
            @click="uploadFileBaseSalePrice()"
            class="bg_m_green"
            v-if="baseSalePriceFileUploaded"
            :disabled="disabledBaseSalePriceBtn"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("UploadFile") }}
          </vs-button>
        </div>
        <div class="flex">
          <label class="custom-file-upload" v-has-permission="permission565">
            <input
              type="file"
              id="file"
              ref="file"
              v-on:change="handleFileUploadFixedPrice()"
            />
            <feather-icon
              icon="PaperclipIcon"
              svgClasses="h-4 w-4"
              class="ico"
            />
            {{ $t("SubmitAndGetFileForFixedPrice") }}
            <span v-if="uploadedFileName" class="file-name">{{
              uploadedFileName
            }}</span>
          </label>
          <vs-button
            @click="uploadFileFixedPrice()"
            class="bg_m_green"
            v-if="fileUploaded"
            :disabled="disabledBtn"
          >
            <feather-icon icon="PlusIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("UploadFile") }}
          </vs-button>
        </div>
      </div>
      <div class="flex justify-end gap-4 flex-grow">
        <vs-button
          @click.prevent="updatePrice"
          class="bg_l_blue"
          v-has-permission="permission66"
        >
          <feather-icon icon="InfoIcon" svgClasses="h-4 w-4" class="ico" />
          {{ $t("UpdatePrice") }}
        </vs-button>
        <vs-button @click="showFilters = !showFilters" class="bg_purple">
          <div class="px-4">
            <feather-icon icon="FilterIcon" svgClasses="h-4 w-4" class="ico" />
            {{ $t("Filter") }}
          </div>
        </vs-button>
      </div>
    </div>

    <div class="vx-row" v-if="showFilters">
      <div class="vx-col w-full">
        <form>
          <div class="vx-row mb-2">
            <div class="vx-col w-full">
              <div class="w-full">
                <div class="vx-row mb-2">
                  <div class="vx-col lg:w-full md:w-2/3 w-full mt-1">
                    <vs-input
                      class="inputx mb-4"
                      v-model="gridSearchData.Name"
                      :label="$t('ProductName')"
                    />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <label class="vs-input--label">{{
                      $t("GenericProduct")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="GenericProducts"
                        v-model="gridSearchData.SaleGenericProductId"
                        :reduce="(x) => x.value"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <label class="vs-input--label">{{ $t("BrandName") }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="BrandNames"
                        v-model="gridSearchData.BrandId"
                        :reduce="(x) => x.value"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <label class="vs-input--label">{{
                      $t("WarrantyName")
                    }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="WarrantyNames"
                        v-model="gridSearchData.WarrantyId"
                        :reduce="(x) => x.value"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <label class="vs-input--label">{{ $t("Quota") }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="Quotas"
                        v-model="gridSearchData.QuotaStatus"
                        :reduce="(x) => x.value"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <label class="vs-input--label">{{ $t("Status") }}</label>
                    <div class="w-full">
                      <v-select
                        label="name"
                        :options="Statuses"
                        v-model="gridSearchData.Status"
                        :reduce="(x) => x.value"
                        dir="rtl"
                      >
                      </v-select>
                    </div>
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <vs-input
                      class="inputx mb-4"
                      v-model="gridSearchData.Color"
                      :label="$t('ColorName')"
                    />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <vs-input
                      class="inputx mb-4"
                      v-model="gridSearchData.ItemCode"
                      :label="$t('ItemCode')"
                    />
                  </div>
                  <div class="vx-col lg:w-1/4 md:w-1/3 sm:w-1/2 w-full mt-1">
                    <vs-input
                      class="inputx mb-4"
                      v-model="gridSearchData.ModelNumber"
                      :label="$t('ModelNumber')"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="vx-row mb-4">
            <div class="vx-col w-full">
              <vs-button
                type="filled"
                class="float-right"
                @click.prevent="submitFilter()"
                >{{ $t("SubmitFilter") }}</vs-button
              >
              <vs-button
                type="filled"
                class="float-right ml-4"
                id="reset-btn"
                @click.prevent="resetForm"
                >{{ $t("ResetFilter") }}</vs-button
              >
            </div>
          </div>
        </form>
      </div>
    </div>
    <template v-if="tabIndex == 1">
      <assign-product-popup
        :show="AssignProductPopup"
        :model="modalModel"
        @finish="onfinish"
      ></assign-product-popup>
    </template>
    <template v-if="tabIndex == 2">
      <assign-configurable-product-popup
        :show="AssignConfigurableProductPopup"
        @finish="onfinishAssignConfigurableProductPopup"
      ></assign-configurable-product-popup>
    </template>
    <template v-if="tabIndex == 2">
      <assign-configurable-product-popup
        :show="AssignConfigurableProductPopup"
        @finish="onfinishAssignConfigurableProductPopup"
      ></assign-configurable-product-popup>
    </template>

    <div class="vx-row">
      <div class="vx-col w-full mb-base">
        <data-grid
          ref="grid"
          stripe
          :data-source="gridDataSource"
          :search-data="gridSearchData"
          :columns="[
            { title: $t('ProductName'), sort: 'ProductName' },
            { title: $t('GenericProduct'), sort: 'GenericProduct' },
            { title: $t('BrandName'), sort: 'BrandName' },
            { title: $t('WarrantyName'), sort: 'WarrantyName' },
            { title: $t('ColorName'), sort: 'ColorName' },
            { title: $t('ItemCode'), sort: 'ItemCode' },
            { title: $t('ModelNumber'), sort: 'ModelNumber' },
            { title: $t('PriceRial'), sort: 'Price' },
            { title: '↓', sort: '↓' },
            { title: '↑', sort: '↑' },
            { title: $t('QuotaCount'), sort: 'QuotaCount' },
            { title: $t('Status'), sort: 'Status' },
            { title: $t('Action'), sort: 'Action' },
          ]"
        >
          <template slot-scope="{ row }">
            <td style="width: 15%" :title="row.productName">
              {{ row.productName | truncate(75) }}
            </td>
            <td style="width: 8%">{{ row.genericProductName }}</td>
            <td style="width: 8%">
              <span v-if="row.brandName != null">
                {{ row.brandName }}
              </span>
              <span v-else>-</span>
            </td>
            <td style="width: 8%">
              <span v-if="row.brandName != null">
                {{ row.warrantyName }}
              </span>
              <span v-else>-</span>
            </td>
            <td style="width: 8%">
              <span v-if="row.brandName != null">
                {{ row.colorName }}
              </span>
              <span v-else>-</span>
            </td>
            <td style="width: 8%">{{ row.itemCode }}</td>
            <td style="width: 8%">
              <span v-if="row.modelNumber">{{ row.modelNumber }}</span>
              <span v-else>-</span>
            </td>
            <td style="width: 11%">
              <vx-tooltip title="بازه قیمت پایه" color="#2F4F4F" position="top">
                <template slot="content">
                  <div class="flex gap-1 justify-center w-full">
                    <span
                      >از
                      {{
                        row.contractProductInfoPriceBoundary
                          ? Math.round(
                              row.contractProductInfoPriceBoundary.priceFloor
                            ).toLocaleString()
                          : "--"
                      }}
                    </span>
                    <span>
                      تا
                      {{
                        row.contractProductInfoPriceBoundary
                          ? Math.round(
                              row.contractProductInfoPriceBoundary.priceCeiling
                            ).toLocaleString()
                          : "--"
                      }}
                    </span>
                  </div>
                </template>
                <div
                  class="flex w-full gap-1 h-full justify-center items-center"
                >
                  <span v-if="row.price != null" class="flex">
                    {{ Number(row.price).toLocaleString() }}</span
                  >
                  <span v-else>-</span>
                  <span v-if="row.priceBoundaryStatus !== 'Unchanged'"
                    ><span class="red-notify w-2 h-2"></span
                  ></span>
                  <span v-if="row.priceBoundaryStatus == 'Unchanged'"
                    ><span class="green-notify w-2 h-2"></span
                  ></span>
                </div>
              </vx-tooltip>
            </td>
            <td style="width: 2%">{{ row.minOrderQuantity }}</td>
            <td style="width: 2%">{{ row.maxOrderQuantity }}</td>
            <td style="width: 2%">
              <span v-if="row.quotaCount || row.quotaCount == 0">
                {{ row.quotaCount }}
              </span>
              <span v-else> - </span>
            </td>
            <td style="width: 7%">
              <span v-if="row.status == 0">{{ $t("ReadyForSale") }}</span>
              <span v-if="row.status == 1">{{ $t("ComingSoon") }}</span>
              <span v-if="row.status == 2">{{ $t("StopSale") }}</span>
              <span v-if="row.status == 3">{{ $t("StopProduction") }}</span>
            </td>
            <td style="width: 10%">
              <div class="flex w-full justify-center gap-1 items-center h-full">
                <vs-button
                  radius
                  color="primary"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-bar-chart-2"
                  @click.prevent="openPoductPriceHistoryPopup(row)"
                ></vs-button>
                <vs-button
                  radius
                  color="primary"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-dollar-sign"
                  @click.prevent="pricePopup(row)"
                ></vs-button>
                <vs-button
                  radius
                  color="success"
                  size="small"
                  type="gradient"
                  icon-pack="feather"
                  icon="icon-edit"
                  @click.prevent="edit(row)"
                  v-has-permission="permission67"
                ></vs-button>
              </div>
            </td>
          </template>
        </data-grid>
      </div>
    </div>
    <edit-product-popup
      :show="EditProductPopup"
      :model="productModel"
      @finish="onPopupsFinish"
      @close="closeEditProductPopup"
    ></edit-product-popup>
    <product-prices-popup
      :show="ProductPricesPopup"
      :model="pricesModel"
      @close="closeProductPricesPopup"
      @update="renderGrid"
    ></product-prices-popup>
    <product-price-history-popup
      :show="productPriceHistoryPopup"
      :itemCode="selectedItemCode"
      @close="closeproductPriceHistoryPopup"
    >
    </product-price-history-popup>

    <div v-show="showUpdateLoading">
      <div id="update-loading"></div>
    </div>
  </div>
</template>
<script>
import { mapActions } from "vuex";
import "@/assets/scss/vuesax-rtl/pages/_custom.scss";
import "@/assets/scss/vuesax-rtl/pages/_sale.scss";
import DataGrid from "@/components/datagrid/DataGrid";
import vSelect from "vue-select";
import AssignProductPopup from "./AssignProductPopup.vue";
import AssignConfigurableProductPopup from "./AssignConfigurableProductPopup.vue";
import EditProductPopup from "./EditProductPopup.vue";
import ProductPricesPopup from "./ProductPricesPopup.vue";
import ProductPriceHistoryPopup from "./ProductPriceHistoryPopup.vue";
export default {
  name: "saleManagement_Contract_Management_Products",

  components: {
    DataGrid,
    "v-select": vSelect,
    AssignProductPopup,
    AssignConfigurableProductPopup,
    EditProductPopup,
    ProductPricesPopup,
    ProductPriceHistoryPopup,
  },
  props: {
    tabIndex: {
      default: {},
    },
  },
  data() {
    var id = this.$route.params.id;
    this.$route.params.SaleProductType;
    return {
      permission64: "AssignContractProductInfo",
      permission65: "GetAllExcelFileOfContractProductInfoByContract",
      permission66: "UpdateContractProductInfoPrice",
      permission67: "ModifyContractProductRuleInfo",
      permission565: "CumulativeUpdatePriceManuallyWithExcel",
      allBrands: [],
      allGenericProducts: [],
      allWarranties: [],
      AssignProductPopup: false,
      AssignConfigurableProductPopup: false,
      modalModel: {},
      ProductPricesPopup: false,
      pricesModel: {},
      productPriceHistoryPopup: false,
      selectedItemCode: "",
      showUpdateLoading: false,
      EditProductPopup: false,
      productModel: {},
      showFilters: false,
      contractId: this.$route.params.id,
      gridDataSource: {
        type: "app",
        service: "/Sales/api/ContractsQuery/" + id + "/0",
      },
      gridSearchData: {
        SaleProductType: this.tabIndex,
        Status: "",
        SaleGenericProductId: "",
        BrandId: "",
        WarrantyId: "",

        Color: "",
        ItemCode: "",
        ModelNumber: "",
        Name: "",
        QuotaStatus: "4",
      },
      GenericProducts: [],
      BrandNames: [],
      WarrantyNames: [],
      Statuses: [
        { name: "آماده فروش", value: "0" },
        { name: "به‌زودی", value: "1" },
        { name: "توقف فروش", value: "2" },
        { name: "توقف تولید", value: "3" },
      ],
      Quotas: [
        { name: "دارد", value: "1" },
        { name: "ندارد", value: "2" },
        { name: "تخصیص داده نشده", value: "3" },
        { name: "همه", value: "4" },
      ],

      file: "",
      fileUploaded: false,
      disabledBtn: false,
      disabledBaseSalePriceBtn: false,
      showLoading: false,
      uploadedFileName: "",
      emptyFileInRefs: "",
      baseSalePriceFile: "",
      baseSalePriceFileUploaded: false,
      baseSalePriceUploadedFileName: "",
      emptyBaseSalePriceFileInRefs: "",
      uploadedBaseSalePriceFileName: "",
    };
  },
  mounted() {
    this.emptyFileInRefs = this.$refs.file.files;
    this.emptyBaseSalePriceFileInRefs = this.$refs.baseSalePriceFile.files;
    this.showListOfBrands();
    this.showListOfGenericProducts();
    this.showListOfWarranties();
  },
  methods: {
    ...mapActions({
      UpdatePriceMethod: "sale/updatePrice",
      showListAllBrands: "sale/showListAllBrands",
      showListAllGenericProducts: "sale/showListAllGenericProducts",
      showListAllWarranties: "sale/showListAllWarranties",
      exportProductsExcel: "excel/exportContractProductsQuery",
      importFixedPriceExcel: "excel/importFixedPriceExcel",
      importBaseSalePriceExcel: "excel/importBaseSalePriceExcel",
    }),
    showListOfBrands() {
      this.showListAllBrands().then((result) => {
        this.allBrands = result;
        this.allBrands.forEach((element) => {
          this.BrandNames.push({
            value: element.id,
            name: element.persianName,
          });
        });
      });
    },
    showListOfGenericProducts() {
      this.showListAllGenericProducts().then((result) => {
        this.allGenericProducts = result;
        this.allGenericProducts.forEach((element) => {
          this.GenericProducts.push({
            value: element.id,
            name: element.name,
          });
        });
      });
    },
    showListOfWarranties() {
      this.showListAllWarranties().then((result) => {
        this.allWarranties = result;
        this.allWarranties.forEach((element) => {
          this.WarrantyNames.push({
            value: element.id,
            name: element.name,
          });
        });
      });
    },
    onfinish() {
      this.AssignProductPopup = false;
      this.$refs.grid.renderGrid();
    },
    onfinishAssignConfigurableProductPopup() {
      this.AssignConfigurableProductPopup = false;
      this.$refs.grid.renderGrid();
    },
    assignProduct() {
      if (this.tabIndex == 1) {
        this.modalModel = {};
        this.AssignProductPopup = true;
      } else if (this.tabIndex == 2) {
        this.AssignConfigurableProductPopup = true;
      }
    },
    pricePopup(model) {
      this.ProductPricesPopup = true;
      this.pricesModel = {
        basePrice: model.basePrice,
        contractBasePrice: model.contractBasePrice,
        contractPrice: model.contractPrice,
        priceWithoutBoundary: model.priceWithoutBoundary,
        price: model.price,
        priceBoundaryStatus: model.priceBoundaryStatus,
        sumOfDiscountsAmount: model.sumOfDiscountsAmount,
        deductionAndIncreaseAmount: model.deductionAndIncreaseAmount,
        totalTax: model.totalTax,
        baseConsumerPrice: model.baseConsumerPrice,
        isAutomatedPriceUpdate: model.isAutomatedPriceUpdate,
        contractId: this.$route.params.id,
        productId: model.productId,
      };
    },
    updatePrice() {
      this.showUpdateLoading = true;
      this.$vs.loading({
        background: this.backgroundLoading,
        color: this.colorLoading,
        container: "#update-loading",
        scale: 1,
        type: "sound",
      });
      this.UpdatePriceMethod(this.$route.params.id).then(() => {
        setTimeout(() => {
          this.$swal({
            position: "center-center",
            type: "success",
            text: "قیمت محصولات قرارداد با موفقیت به روزرسانی شد!",
            showConfirmButton: false,
            timer: 2000,
          });
          this.$refs.grid.renderGrid();
        }, 3000);
      });
      setTimeout(() => {
        this.$vs.loading.close("#update-loading > .con-vs-loading");
        this.showUpdateLoading = false;
      }, 3000);
    },
    edit(model) {
      this.productModel = {
        contractId: this.$route.params.id,
        tabIndex: this.$route.params.SaleProductType,
        productId: model.productId,
        minOrderQuantity: model.minOrderQuantity,
        maxOrderQuantity: model.maxOrderQuantity,
        limitationOnPurchase: model.limitationOnPurchase,
        status: model.status,
      };
      this.EditProductPopup = true;
    },
    closeEditProductPopup() {
      this.EditProductPopup = false;
    },
    closeProductPricesPopup() {
      this.ProductPricesPopup = false;
    },
    onPopupsFinish() {
      this.closeEditProductPopup();
      this.closeProductPricesPopup();
      this.$refs.grid.renderGrid();
    },
    downloadFile() {
      const id = this.contractId;
      const SaleProductType = this.tabIndex;
      this.exportProductsExcel({ id, SaleProductType });
    },
    submitFilter() {
      this.$refs.grid.renderGrid();
    },
    resetForm() {
      this.gridSearchData = { SaleProductType: this.tabIndex };
      setTimeout(() => {
        this.$refs.grid.renderGrid();
      }, 0);
    },
    removeUploadFile() {
      this.file = "";
      this.$refs.file.files = this.emptyFileInRefs;
      this.uploadedFileName = "";
      this.fileUploaded = false;
    },
    removeUploadBaseSalePriceFile() {
      this.baseSalePriceFile = "";
      this.$refs.baseSalePriceFile.files = this.emptyBaseSalePriceFileInRefs;
      this.uploadedBaseSalePriceFileName = "";
      this.baseSalePriceFileUploaded = false;
    },
    handleFileUploadFixedPrice() {
      this.file = this.$refs.file.files[0];
      this.uploadedFileName = this.file.name;
      this.fileUploaded = true;
    },
    handleFileUploadBaseSalePrice() {
      this.baseSalePriceFile = this.$refs.baseSalePriceFile.files[0];
      this.uploadedBaseSalePriceFileNameFileName = this.baseSalePriceFile.name;
      this.baseSalePriceFileUploaded = true;
    },
    uploadFileFixedPrice() {
      this.showLoading = true;
      this.disabledBtn = true;
      let formData = new FormData();
      formData.append("file", this.file);
      this.importFixedPriceExcel(formData).then(() => {
        setTimeout(() => {
          this.$refs.grid.renderGrid(1, true);
        }, 3000);
      });
      setTimeout(() => {
        this.removeUploadFile();
        this.disabledBtn = false;
        this.showLoading = false;
      }, 1000);
    },
    uploadFileBaseSalePrice() {
      this.showLoading = true;
      this.disabledBaseSalePriceBtn = true;
      let formData = new FormData();
      formData.append("file", this.baseSalePriceFile);
      this.importBaseSalePriceExcel({
        file: formData,
        id: this.contractId,
      }).then(() => {
        this.$swal({
          position: "center-center",
          type: "success",
          text: "فایل  مارکت پرایس آپلود شد",
          showConfirmButton: false,
          timer: 2000,
        });
      });
      setTimeout(() => {
        this.removeUploadBaseSalePriceFile();
        this.disabledBaseSalePriceBtn = false;
        this.showLoading = false;
        this.$refs.grid.renderGrid(1, true);
      }, 1000);
    },
    renderGrid() {
      this.$refs.grid.renderGrid();
    },
    openPoductPriceHistoryPopup(row) {
      this.selectedItemCode = row.itemCode;
      this.productPriceHistoryPopup = true;
    },
    closeproductPriceHistoryPopup() {
      this.productPriceHistoryPopup = false;
    },
  },
};
</script>
